export const links = [
    {
    title: "Spotify",
    url: "https://open.spotify.com/artist/0T62YioSTCaw1NRFNbE4lE?si=s36brJ5sT1GtdAxgegRz2A",
    type: "spotify",
    iconColor: "#1DB954"
    },
    {
    title: "Beatport",
    url: "https://www.beatport.com",
    type: "beatport",
    iconColor: "#01FF95"
    },
    {
    title: "SoundCloud",
    url: "https://soundcloud.com/kid-diagnostic?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
    type: "soundcloud",
    iconColor: "#FF5500"
    },
    {
    title: "YouTube",
    url: "https://www.youtube.com/@DiagnosticMusic0",
    type: "youtube",
    iconColor: "#FF0000"
    },
    // {
    //     title: "Apple Music",
    //     url: "https://music.apple.com/us/artist/diagnostic/1539290133",
    //     type: "apple",
    //     iconColor: "#fff"
    // }
];